import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

const Work = () => {
  const navigate = useNavigate();

  const projects = [
    {
      name: "STOCKPILE",
      technology: "— React Native App"
    },
    {
      name: "INTERFACE",
      technology: "— Framer Development"
    },
    {
      name: "FLOWGUARD",
      technology: "— Intelligent Control"
    },
    {
      name: "CLINICFLOW",
      technology: "— Framer Development"
    }
  ];

  const pageVariants = {
    initial: {
      y: "100vh",
      opacity: 0
    },
    animate: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.8,
        ease: [0.25, 0.46, 0.45, 0.94],
        staggerChildren: 0.1
      }
    },
    exit: {
      y: "100vh",
      opacity: 0,
      transition: {
        duration: 0.6,
        ease: [0.25, 0.46, 0.45, 0.94]
      }
    }
  };

  const leftColumnVariants = {
    initial: {
      opacity: 0,
      y: 30
    },
    animate: {
      opacity: 1,
      y: 0,
      transition: {
        delay: 0.2,
        duration: 0.6,
        ease: [0.25, 0.46, 0.45, 0.94]
      }
    }
  };

  const rightColumnVariants = {
    initial: {
      opacity: 0,
      y: 30
    },
    animate: {
      opacity: 1,
      y: 0,
      transition: {
        delay: 0.4,
        duration: 0.6,
        ease: [0.25, 0.46, 0.45, 0.94]
      }
    }
  };

  return (
    <motion.div
      className="min-h-screen bg-black text-white font-sans selection:bg-white selection:text-black overflow-hidden relative"
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
    >
      {/* Top-left HOME button - Vertical text */}
      {/* Top-left HOME button - Vertical text */}
      <motion.button
        onClick={() => navigate('/')}
        className="fixed top-0 left-0 z-50 flex flex-col items-center group hidden md:flex"
        style={{
          padding: '20px'
        }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.3 }}
      >
        <motion.span
          className="text-white text-sm font-medium"
          style={{
            writingMode: 'vertical-rl',
            textOrientation: 'mixed',
            transform: 'rotate(180deg)'
          }}
          whileHover={{ letterSpacing: "0.2em" }}
          transition={{ duration: 0.3, ease: "easeOut" }}
        >
          HOME
        </motion.span>
        {/* Vertical line below HOME text */}
        <motion.div
          className="w-[1px] bg-white"
          initial={{ height: '80px', opacity: 0.6 }}
          whileHover={{ height: '100px', opacity: 1 }}
          transition={{ duration: 0.3, ease: "easeOut" }}
          style={{
            marginTop: '20px'
          }}
        />
      </motion.button>

      <div className="flex flex-col md:flex-row h-screen">
        {/* Left Column - Description */}
        <motion.div
          className="w-full md:w-2/5 p-8 md:p-20 flex flex-col justify-between border-b md:border-b-0 md:border-r border-white/10"
          variants={leftColumnVariants}
        >
          {/* Mobile Top Bar - HOME + Line */}
          <div className="md:hidden flex items-center mb-12 w-full gap-4">
            <button
              onClick={() => navigate('/')}
              className="text-white text-sm font-medium tracking-widest uppercase"
            >
              HOME
            </button>
            <div className="h-[1px] bg-white w-24 opacity-20"></div>
          </div>

          <div className="pt-4 md:pt-0">
            {/* WORK Title */}
            <h1 className="text-xl md:text-2xl font-medium mb-6 md:mb-8 tracking-widest text-white/50">WORK</h1>

            {/* Description Text */}
            <div className="space-y-4 md:space-y-6 text-sm md:text-base leading-relaxed text-white/80">
              <p>
                Specialized in building robust digital solutions, including React Native mobile apps,
                Permit To Work (PTW) systems, healthcare automation tools, and premium website designs.
              </p>
              <p>
                From technical architecture to visual polish, I create intelligent systems that streamline
                complex workflows while delivering stunning user experiences.
              </p>
            </div>
          </div>

          {/* Bottom Section - Visible on Desktop or at end of scroll */}
          <div className="hidden md:block space-y-4 text-xs font-mono opacity-40">
            <p>© 2025</p>
            <p className="hover:opacity-100 transition-opacity">https://portfolio.com/work</p>
          </div>
        </motion.div>

        {/* Right Column - Projects */}
        <motion.div
          className="w-full md:w-3/5 p-8 md:p-20 overflow-y-auto h-full no-scrollbar"
          variants={rightColumnVariants}
        >
          <div className="flex flex-col justify-start space-y-8 md:space-y-12 pt-4 md:pt-0">
            {projects.map((project, index) => (
              <motion.div
                key={index}
                className="group cursor-pointer"
                initial={{ opacity: 0, y: 20 }}
                animate={{
                  opacity: 1,
                  y: 0,
                  transition: {
                    delay: 0.6 + index * 0.1,
                    duration: 0.5,
                    ease: [0.25, 0.46, 0.45, 0.94]
                  }
                }}
                whileHover={{ x: 10 }}
                transition={{ duration: 0.3, ease: "easeOut" }}
                onClick={() => {
                  if (project.name === "STOCKPILE") {
                    navigate('/stockpile');
                  } else if (project.name === "INTERFACE") {
                    navigate('/interface');
                  } else if (project.name === "FLOWGUARD") {
                    navigate('/flowguard');
                  } else if (project.name === "CLINICFLOW") {
                    navigate('/clinicflow');
                  }
                }}
              >
                <h2 className="text-4xl sm:text-5xl md:text-7xl mb-2 group-hover:opacity-80 transition-opacity bonky-font">
                  {project.name}
                </h2>
                <p className="text-xs md:text-sm opacity-60 group-hover:opacity-80 transition-opacity tracking-widest uppercase">
                  {project.technology}
                </p>
              </motion.div>
            ))}
          </div>

        </motion.div>
      </div >
    </motion.div >
  );
};

export default Work;